<template>
    <div class="container">
        <div class="col-md-12">
            <h2>{{ labels.title }}</h2>
        </div>
        <b-container>
            <!-- Filtros principales - Centrados -->
            <b-row class="mb-4 justify-content-center">
                <!-- Reporte -->
                <b-col md="4">
                    <label class="d-block fw-bold" style="font-size: 1.3rem;"><b>{{ labels.report }}</b></label>
                    <select v-model="selReporte"
                        @click="f_lea_primer_nivel(); f_lea_segundo_nivel(); listPlanConsoli = []; fgl_consulta = false"
                        class="form-control form-control-lg">
                        <option value="">{{ labels.select }}</option>
                        <option v-for="reporte in listReporte" :key="reporte.id" :value="reporte.codigo">
                            {{ reporte.nombre }}
                        </option>
                    </select>
                </b-col>
                <!-- Vigencia -->
                <b-col md="4">
                    <label class="d-block fw-bold" style="font-size: 1.3rem;"><b>{{ labels.validity }}</b></label>
                    <select v-model="selVigencia" @click="listPlanConsoli = []; fgl_consulta = false"
                        class="form-control form-control-lg">
                        <option value="">{{ labels.select }}</option>
                        <option v-for="vigencia in listVigencia" :key="vigencia.vigencia">
                            {{ vigencia.vigencia }}
                        </option>
                    </select>
                </b-col>
            </b-row>

            <!-- Botón Consultar -->
            <b-row class="mb-4 justify-content-center">
                <b-col md="12" class="text-center">
                    <b-button @click="consultaNiif(); fgl_consulta = true" id="consult-btn" size="lg"
                        variant="outline-primary">
                        <b-icon icon="search" class="me-2"></b-icon>
                        {{ labels.consultar }}
                    </b-button>
                </b-col>
            </b-row>

            <!-- Resultados de la consulta -->
            <div v-if="fgl_consulta">
                <b-row class="mb-4 align-items-end">
                    <!-- Buscador -->
                    <b-col md="4">
                        <label class="d-block fw-bold text-dark mb-2" style="font-size: 1.1rem;">{{ labels.search
                            }}</label>
                        <b-form-input v-model="searchNiif" @input="searchOnTableNiif" class="form-control"
                            :placeholder="labels.search + '...'">
                        </b-form-input>
                    </b-col>

                    <b-col md="2" class="d-flex align-items-end">
                        <b-button @click="borraCriterio" variant="outline-secondary" class="w-100"
                            style="height: 38px;">
                            <b-icon icon="arrow-counterclockwise" class="me-2"></b-icon>
                            {{ labels.clear }}
                        </b-button>
                    </b-col>

                    <!-- Botón Crear -->
                    <b-col md="2" class="d-flex align-items-end">
                        <b-button @click="crearNiif()" variant="primary" class="w-100" style="height: 38px;">
                            <b-icon icon="plus" class="me-2"></b-icon>
                            {{ labels.create }}
                        </b-button>
                    </b-col>

                    <!-- Selector de registros -->
                    <b-col md="4" class="d-flex align-items-end">
                        <b-form-select v-model="itemLimit" :options="limitOptions" size="md" style="width: 100%;"
                            @change="resetVisibleItems">
                        </b-form-select>
                    </b-col>
                </b-row>

                <!-- Contador -->
                <b-row class="mb-3">
                    <b-col md="12">
                        <div class="text-muted text-center">
                            {{ labels.showing }} <strong>{{ visibleItems.length }}</strong> {{ labels.of }}
                            <strong>{{ listPlanConsoli.length }}</strong> {{ labels.records }}
                        </div>
                    </b-col>
                </b-row>

                <!-- Tabla -->
                <b-row>
                    <b-col md="12">
                        <div class="table-responsive custom-scroll-container" ref="scrollContainer">
                            <table class="table table-hover table-bordered">
                                <thead style="background-color: #4a90e2;">
                                    <tr>
                                        <th scope="col" class="text-center text-white border-0"
                                            style="font-weight: 600;">{{
                                            labels.niif }}</th>
                                        <th scope="col" class="text-center text-white border-0"
                                            style="font-weight: 600;">{{
                                            labels.description }}</th>
                                        <th scope="col" class="text-center text-white border-0"
                                            style="font-weight: 600;">{{
                                            labels.levelFirst }}</th>
                                        <th scope="col" class="text-center text-white border-0"
                                            style="font-weight: 600;">{{
                                            labels.levelSecond }}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="planCons in visibleItems" :key="planCons.id"
                                        @click="editaNiif(planCons.id)" class="clickable-row">
                                        <td class="text-center"><strong class="text-dark">{{ planCons.niif }}</strong>
                                        </td>
                                        <td class="text-left">{{ planCons.nameNiif }}</td>
                                        <td class="text-left">{{ planCons.namePrimerNivel }}</td>
                                        <td class="text-left">{{ planCons.nameSegundoNivel }}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </b-col>
                </b-row>
            </div>

            <!-- Mensaje cuando no hay datos -->
            <div v-else class="mt-4 text-center">
                <div class="h4 text-muted">
                    <b-icon icon="inbox" class="me-2"></b-icon>
                    {{ labels.noData }}
                </div>
            </div>
        </b-container>
        <div v-if="!isLoading"></div>
        <div class="loadingSpinner" :class="{ active: isLoading }">
            <b-spinner></b-spinner>
        </div>

        <!-- Modal de Edición con botón Eliminar -->
        <Edit :showDialogEditNiif="showDialogEditNiif" @clicked="closeModal" :Item="itemSelected"
            :listFirstLevel="listFirstLevel" :listSecondLevelFirst="listSecondLevelFirst"
            @leaSegundoNivel="leaSegundoNivel" :listNiif="listPlanConsoli" @reload="refrescaTabla"
            @delete-item="deleteNiif" />

        <Crear :showDialogCrearNiif="showDialogCrearNiif" :vigencia="vigenciaSelected" :codReporte="selReporte"
            :listFirstLevel="listFirstLevel" @clicked="closeModal" @reload="refrescaTabla" />

        <InacticaItem :InactivaItem="showModDel" @confirmDelete="confirmDel" @cierraModal="closeModal" />
    </div>
</template>

<script>
import PlanConsolidacion from '../../services/PlanConsolidacion';
import TipoReporte from '../../services/TipoReporte';
import PrimerNivel from '../../services/PrimerNivel'
import SegundoNivel from '../../services/SegundoNivel'
import InacticaItem from '../utils/InacticaItem.vue';
import Crear from './Crear.vue';
import Edit from './Edit.vue';

const toLower = (text) => {
    return text.toString().toLowerCase();
};

const searchByNiif = (items, term) => {
    if (term) {
        const termLower = toLower(term);
        return items.filter((item) => {
            // Buscar por código Niif
            if (item.niif && toLower(item.niif.toString()).includes(termLower)) {
                return true;
            }
            // Buscar por descripción
            if (item.nameNiif && toLower(item.nameNiif).includes(termLower)) {
                return true;
            }
            return false;
        });
    }
    return items;
};

export default {
    name: "Niif",
    data: () => ({
        fgl_consulta: false,
        companyId: "",
        selVigencia: "",
        searchNiif: null,
        listPlanConsoli: [],
        listPlanConsoliOrigen: [],
        elementosPorPagina: 10,
        datosPaginados: [],
        paginaActual: 1,
        showDialogCrearNiif: false,
        showDialogEditNiif: false,
        listFirstLevel: [],
        listSecondLevel: [],
        listSecondLevelFirst: [],
        nuevoNiif: {},
        itemSelected: {},
        listVigencia: [],
        isLoading: false,
        showBtnCrear: false,
        vigenciaSelected: "",
        selReporte: "",
        listReporte: [],
        showModDel: false,
        rowDelete: null,
        itemLimit: 100,
        visibleItems: [],
        limitOptions: [
            { value: 100, text: '100 registros' },
            { value: 200, text: '200 registros' },
            { value: 500, text: '500 registros' },
            { value: 0, text: 'Mostrar todo' }
        ]
    }),
    components: {
        Edit,
        Crear,
        InacticaItem
    },
    computed: {
        labels() {
            if (this.$store.state._language == "es-ES") {
                return {
                    title: "NIIF",
                    select: "Seleccione...",
                    search: "Buscar",
                    create: "Crear",
                    niif: "Niif",
                    company: "Compañía",
                    validity: "Vigencia",
                    report: "Reporte",
                    description: "Descripción",
                    levelFirst: "Primer Nivel",
                    levelSecond: "Segundo Nivel",
                    consultar: "Consultar",
                    edit: "Editar",
                    delete: "Eliminar",
                    previous: "Ant.",
                    next: "Sig.",
                    clear: "Limpiar",
                    showing: "Mostrando",
                    of: "de",
                    records: "registros",
                    noData: "No hay datos"
                }
            } else {
                return {
                    title: "NIIF",
                    select: "Select...",
                    search: "Search",
                    create: "Create",
                    niif: "Niif",
                    company: "Company",
                    validity: "Validity",
                    report: "Report",
                    description: "Description",
                    levelFirst: "Level First",
                    levelSecond: "Level Second",
                    consultar: "Consult",
                    edit: "Edit",
                    delete: "Delete",
                    previous: "Previous",
                    next: "Next",
                    clear: "Clear",
                    showing: "Showing",
                    of: "of",
                    records: "records",
                    noData: "No data"
                }
            }
        }
    },
    methods: {
        f_lea_primer_nivel() {
            PrimerNivel.getFirstLevelByReporte(this.selReporte)
                .then((r_primerNivel) => {
                    this.listFirstLevel = r_primerNivel.data.firstLevByReport
                })
        },
        f_lea_segundo_nivel() {
            SegundoNivel.getAllLevelSecond(this.selReporte)
                .then((r_segundoNivel) => {
                    this.listSecondLevel = r_segundoNivel.data.segundoNivel
                })
        },
        crearNiif() {
            this.showDialogCrearNiif = true
            this.vigenciaSelected = this.selVigencia
        },
        editaNiif(id) {
            this.itemSelected = this.listPlanConsoli.find((d_niif) => d_niif.id === id)
            this.itemSelected.descripcion = this.itemSelected.nameNiif
            this.itemSelected.codReporte = this.selReporte
            this.itemSelected.vigencia = this.selVigencia
            this.itemSelected.niif_nuevo = this.itemSelected.niif

            this.listSecondLevelFirst = this.listSecondLevel.filter((d_second) => d_second.primer_nivel == this.itemSelected.primer_nivel)
            this.showDialogEditNiif = true
        },
        borraCriterio() {
            this.searchNiif = ''
            // Restaurar lista completa cuando se limpian filtros
            this.listPlanConsoli = this.listPlanConsoliOrigen || this.listPlanConsoli
            this.resetVisibleItems()
        },

        resetVisibleItems() {
            if (this.itemLimit === 0) {
                // Mostrar todos los registros
                this.visibleItems = [...this.listPlanConsoli];
            } else {
                this.visibleItems = this.listPlanConsoli.slice(0, this.itemLimit);
            }
        },

        consultaNiif() {
            this.isLoading = true;
            this.showBtnCrear = true;

            PlanConsolidacion.getPlanConsPorCompVige(this.selVigencia, this.selReporte)
                .then((res) => {
                    this.listPlanConsoli = res.data.planConsNiif
                    this.listPlanConsoliOrigen = [...this.listPlanConsoli]
                    this.resetVisibleItems();
                })
                .catch((err) => {
                    console.log(err)
                })
                .finally(() => {
                    this.isLoading = false;
                })
        },
        leaSegundoNivel(p_primer_nivel) {
            const SecondLevelFirst = this.listSecondLevel.filter((d_second) => d_second.primer_nivel == p_primer_nivel)
            this.listSecondLevelFirst = SecondLevelFirst
        },
        deleteNiif(id) {
            this.rowDelete = id
            this.showModDel = true
        },
        confirmDel() {
            PlanConsolidacion.deletePlanconsolidacion(this.rowDelete)
                .then((res) => {
                    this.$toast.success(res.data.message)
                    this.refrescaTabla(this.selVigencia, this.selReporte)
                    this.showModDel = false
                    this.showDialogEditNiif = false // Cerrar modal de edición también
                })
                .catch((err) => console.log(err))
        },
        closeModal(value) {
            this.showDialogEditNiif = value
            this.showDialogCrearNiif = value
            this.showModDel = value
        },
        refrescaTabla() {
            this.isLoading = true
            this.consultaNiif()
            this.fgl_consulta = true
        },
        searchOnTableNiif() {
            if (this.searchNiif) {
                this.listPlanConsoli = searchByNiif(this.listPlanConsoliOrigen, this.searchNiif);
            } else {
                this.listPlanConsoli = [...this.listPlanConsoliOrigen];
            }
            this.resetVisibleItems();
        },
        totalPaginas() {
            return Math.ceil(this.listPlanConsoli.length / this.elementosPorPagina)
        },
        getDataPagina(noPagina) {
            this.datosPaginados = [];
            this.paginaActual = noPagina;
            let ini = (noPagina * this.elementosPorPagina) - this.elementosPorPagina;
            let fin = (noPagina * this.elementosPorPagina);

            this.datosPaginados = this.listPlanConsoli.slice(ini, fin);
        }
    },
    mounted() {
        this.isLoading = true;

        PlanConsolidacion.getVigenciaPlanCons()
            .then((res) => {
                this.listVigencia = res.data.getVigencia
            })
            .catch((err) => {
                console.log(err)
            })
            .finally(() => {
                this.isLoading = false;
            })

        TipoReporte.getAllTipoReporte()
            .then((res) => {
                this.listReporte = res.data.typeReport
            })
            .catch((err) => {
                console.log(err)
            })
            .finally(() => {
                this.isLoading = false;
            })
    }
}
</script>

<style>
.clickable-row {
    cursor: pointer;
    transition: background-color 0.2s ease;
}

.clickable-row:hover {
    background-color: #f8f9fa;
}

.loadingSpinner {
    display: none;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(255, 255, 255, 0.8);
    z-index: 9999;
    justify-content: center;
    align-items: center;
}

.loadingSpinner.active {
    display: flex;
}

.custom-scroll-container {
    max-height: 600px;
    overflow-y: auto;
}

.table-responsive {
    border-radius: 8px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}
</style>